/**
 * Canonical UUID shape check for route params that index uuid-keyed rows
 * (`/social/posts/:id`, `/social/designs/:id`). A non-UUID id can never match
 * a row — the API answers 422 (FastAPI UUID validation) — so detail queries
 * gate on this and the page renders its not-found state without a request.
 * Origin: route-sweep probes of `/social/posts/1` + `/social/designs/1`
 * produced 103 recurring 422 runtime errors each (2026-09-24).
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string | null | undefined): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}
